import { StyleSheet } from 'react-native'

// 公用样式可以写在这里进行全局引用
const appStyles = StyleSheet.create({
  container: {
    display: 'flex',
    flex: 1
  },
  flexRow: {
    flexDirection: 'row'
  },
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  alignStart: {
    alignItems: 'flex-start',
    justifyContent: 'center'
  },
  alignEnd: {
    alignItems: 'flex-end',
    justifyContent: 'center'
  },
  justifyStart: {
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  justifyEnd: {
    alignItems: 'center',
    justifyContent: 'flex-end'
  }
})

export default appStyles